module.exports = __webpack_public_path__ + "static/media/addOrange.cb739dd4.svg";